import styled from 'styled-components'

export const Wrapper = styled.div`
  grid-column-start: 1;
  grid-column-end: 12;
`
